var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCard = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#c9b4a8",
    height: "64px",
    width: "64px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 463 463",
    xmlSpace: "preserve",
    stroke: "#fff",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -540.36)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M357.35,540.36h-253c-21.9,0-40.4,18.3-40.4,39.9v382c0,22.7,18.1,41.1,40.4,41.1h253c23,0,41.7-18.4,41.7-41.1v-382 C399.05,558.26,380.35,540.36,357.35,540.36z M384.15,962.26c0,14.6-11.8,26.1-26.7,26.1h-253c-13.8,0-25.4-12-25.4-26.1v-382 c0-13.3,11.9-24.9,25.4-24.9h253c14.5,0,26.7,11.4,26.7,24.9V962.26z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.45,
    cy: 962.858,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.65,955.36h-34.2c-5,0-8.9-4.3-8.9-9.9v-32.4c0-4.1-3.4-7.5-7.5-7.5c-4.1,0-7.5,3.4-7.4,7.5v32.4 c0,13.7,10.7,24.9,23.9,24.9h34.1c4.1,0,7.5-3.4,7.5-7.5S159.75,955.36,155.65,955.36z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.65,
    cy: 580.858,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.65,573.36h-34.2c-4.1,0-7.5,3.4-7.5,7.5s3.4,7.5,7.5,7.5h34.2c5,0,8.9,4.3,8.9,9.9v32.4c0,4.1,3.4,7.5,7.5,7.5 c4.1,0,7.5-3.4,7.5-7.5v-32.4C365.55,584.56,354.85,573.36,341.65,573.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.45,783.46l-75.9-99.6c-1.4-1.9-3.6-3-6-3c-2.4,0-4.5,1.1-6,3l-75.9,99.6c-1.3,1.7-1.8,3.9-1.4,6.1 c0.4,2.1,1.8,4,3.7,5l37.9,21.2c2.3,1.3,5,1.3,7.3,0l19.8-11c-4.8,12.4-10,27.1-10,33.1c0,13.7,10.7,24.9,23.9,24.9 c14.4,0,25.2-10.7,25.2-24.9c0-6.1-5.7-21.1-11-33.6l20.7,11.5c1.1,0.6,2.4,0.9,3.7,0.9s2.5-0.3,3.7-0.9l37.9-21.2 c1.9-1.1,3.2-2.9,3.7-5S314.75,785.26,313.45,783.46L313.45,783.46z M230.95,847.76c-5,0-8.9-4.4-8.9-9.9 c0-3.2,4.1-15.1,9.2-28.1c5.4,12.9,9.9,24.8,10,28.1C241.15,843.66,236.95,847.76,230.95,847.76z M269.45,800.56l-34.3-19.1 c-1.1-0.6-2.4-0.9-3.7-0.9c-1.3,0-2.5,0.3-3.7,0.9l-34.3,19.1l-26.7-14.9l64.7-84.8l64.7,84.8L269.45,800.56z"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card.9ba536aac1eec58d832cf0d2da00c46e.svg";